import Vue from 'vue';
import Router from 'vue-router';

import Login from '@/view/page/Login'

import Index from '@/view/page/Index'

import Welcome from '@/view/page/Welcome'

// 机构管理 - 机构管理
import OrganManage from '@/view/page/OrganizationManage/OrganManage'
import AddOrganManage from '@/view/page/OrganizationManage/AddOrganManage'
import OrganManageParams from '@/view/page/OrganizationManage/OrganManageParams'


import LevelPublicPlatoonTest from '@/view/page/OrganizationManage/LevelPublicPlatoonTest'
import LevelPublicPlatoon from '@/view/page/OrganizationManage/LevelPublicPlatoon'
import LevelPublicPreLicensing from '@/view/page/OrganizationManage/LevelPublicPreLicensing'

//用户管理
import AAmerchantrates from '@/view/page/OrganizationManage/AAmerchantrates' 
import AAmerchantMange from '@/view/page/OrganizationManage/AAmerchantMange'
import OrganUser from '@/view/page/OrganizationManage/OrganUser'
import ImplementInfo from '@/view/page/OrganizationManage/ImplementInfo'
import MerchantInfo from '@/view/page/OrganizationManage/MerchantInfo'
import CopyMerchantInfo from '@/view/page/OrganizationManage/CopyMerchantInfo'
import CopyMerchantInfoManage from '@/view/page/OrganizationManage/CopyMerchantInfoManage'
import CopyMerchantInfoFeilv from '@/view/page/OrganizationManage/CopyMerchantInfoFeilv'
import MemberUpgrade from '@/view/page/OrganizationManage/MemberUpgrade'
import SettleManage from '@/view/page/OrganizationManage/SettleManage'
import PartnerLevelManage from '@/view/page/OrganizationManage/PartnerLevelManage'
import PartnerLookInfo from '@/view/page/OrganizationManage/PartnerLookInfo'
import UpgradeAssessment from '@/view/page/OrganizationManage/UpgradeAssessment'
import AgentPerformance from '@/view/page/OrganizationManage/AgentPerformance'
import AgentPerformanceDetails from '@/view/page/OrganizationManage/AgentPerformanceDetails'
import IdentityManage from '@/view/page/OrganizationManage/IdentityManage'
import AccountSupervise from '@/view/page/OrganizationManage/AccountSupervise'
import PartnerLevelInfo from '@/view/page/OrganizationManage/PartnerLevelInfo'
import MerchantEvaluation from '@/view/page/OrganizationManage/MerchantEvaluation'
import CloudFlashPayment from '@/view/page/OrganizationManage/CloudFlashPayment'

// 机构管理 - 机构管理
import MemberChannelRank from '@/view/page/OrganizationManage/MemberChannelRank'



import OrganNoteSend from '@/view/page/OrganizationManage/OrganNoteSend'



import MemberSelectTwo from '@/view/page/OrganizationManage/MemberSelectTwo'

import OrganBlack from '@/view/page/OrganizationManage/OrganBlack'


import OrganRate from '@/view/page/OrganizationManage/OrganRate'

import AddOrganRate from '@/view/page/OrganizationManage/AddOrganRate'

import OrganNote from '@/view/page/OrganizationManage/OrganNote'


import OrganCertification from '@/view/page/OrganizationManage/OrganCertification'


import CashManage from '@/view/page/OrganizationManage/CashManage'
import PayManage from '@/view/page/OrganizationManage/PayManage'
import RefundManage from '@/view/page/OrganizationManage/RefundManage'
import RefundManageInner from '@/view/page/OrganizationManage/RefundManageInner'

import OnlineApplicationCard from '@/view/page/OrganizationManage/OnlineApplicationCard'

import CardEvaluation from '@/view/page/OrganizationManage/CardEvaluation'


import AppAreaManage from '@/view/page/OrganizationManage/AppAreaManage'

import AppUpload from '@/view/page/OrganizationManage/AppUpload'

import AppAreaDetail from '@/view/page/OrganizationManage/AppAreaDetail'
import CustomConfiguration from '@/view/page/ChannelManage/CustomConfiguration'


import ChangeChannelManage from '@/view/page/ChannelManage/ChangeChannelManage'

import EmptyCashPlanDetails from '@/view/page/TransactionManage/EmptyCashPlanDetails'

import PlanDetails from '@/view/page/TransactionManage/PlanDetails'


import RepaymentDetails from '@/view/page/TransactionManage/RepaymentDetails'
import TwoPublicPlatoon from '@/view/page/TransactionManage/TwoPublicPlatoon'
import DandelionDotSort from '@/view/page/TransactionManage/DandelionDotSort'

import HBCollection from '@/view/page/TransactionManage/HBCollection'

import Message from '@/view/page/TransactionManage/Message'
import Certification from '@/view/page/TransactionManage/Certification'
import CreditCard from '@/view/page/TransactionManage/CreditCard'
import HistoryUPLevel from '@/view/page/TransactionManage/HistoryUPLevel'

// 星钻管理

// 财务管理

import BonusPlan from '@/view/page/FinanceManage/BonusPlan'

import TransferAccountsSh from '@/view/page/FinanceManage/TransferAccountsSh'

import AccountManage from '@/view/page/FinanceManage/AccountManage'

import OfflinePaymentReview from '@/view/page/FinanceManage/OfflinePaymentReview'

import OfflineQRCode from '@/view/page/FinanceManage/OfflineQRCode'

import WithdrawalReview from '@/view/page/FinanceManage/WithdrawalReview'  //厦门银行提现审核

import ConnectWithdrawalReview from '@/view/page/FinanceManage/ConnectWithdrawalReview'  //通联提现审核

import PrivateCashOut from '@/view/page/FinanceManage/PrivateCashOut'

import ResultOnlineCard from '@/view/page/FinanceManage/ResultOnlineCard'

import AccountAdjustmentDetail from '@/view/page/FinanceManage/AccountAdjustmentDetail'

import SettlementDetail from '@/view/page/FinanceManage/SettlementDetail'

import OutAccountDetail from '@/view/page/FinanceManage/OutAccountDetail'

import RepaymentDetail from '@/view/page/FinanceManage/RepaymentDetail'

import NewAwardDetail from '@/view/page/FinanceManage/NewAwardDetail'



import ReceiveDetailNew from '@/view/page/FinanceManage/ReceiveDetailNew'

import InventedDetail from '@/view/page/FinanceManage/InventedDetail'

import InventedDetailNew from '@/view/page/FinanceManage/InventedDetailNew'

import InventedRewardDetail from '@/view/page/FinanceManage/InventedRewardDetail'

import InventedRewardDetailNew from '@/view/page/FinanceManage/InventedRewardDetailNew'




import ServiceManage from '@/view/page/FinanceManage/ServiceManage'


import MemberAccountDetail from '@/view/page/FinanceManage/MemberAccountDetail'


import MemberLevelDetail from '@/view/page/FinanceManage/MemberLevelDetail'

import CatchManage from '@/view/page/FinanceManage/CatchManage'


import PlatformAssets from '@/view/page/FinanceManage/PlatformAssets'


import DailyStatistics from '@/view/page/StatisticsManage/DailyStatistics'

import OrganProfitStatistics from '@/view/page/StatisticsManage/OrganProfitStatistics'
import ChnPlanStatistics from '@/view/page/StatisticsManage/ChnPlanStatistics'
import Withdrawal from '@/view/page/StatisticsManage/Withdrawal'

//系统管理模块
import SelectManage from '@/view/page/SystemManage/SelectManage'
import DictionaryManage from '@/view/page/SystemManage/DictionaryManage'
import SystemPropertiesManage from '@/view/page/SystemManage/SystemPropertiesManage'
import Broker from '@/view/page/SystemManage/Broker'
import Businesses from '@/view/page/SystemManage/Businesses'
import peopeizhi from '@/view/page/SystemManage/peopeizhi'
import SystemPropertiesConfig from '@/view/page/SystemManage/SystemPropertiesConfig'
import SmsWarning from '@/view/page/SystemManage/SmsWarning'
import ChannelNoteSend from '@/view/page/SystemManage/ChannelNoteSend'
import PushInfo from '@/view/page/SystemManage/PushInfo'

import UserManage from '@/view/page/PowerManage/UserManage'

import RoleManage from '@/view/page/PowerManage/RoleManage'
import MenuManage from '@/view/page/PowerManage/MenuManage'

import OtherService from '@/view/page/ValueAddManage/OtherService'

import MemberBasicInfo from '@/view/page/OrganizationManage/MemberBasicInfo'
import PersonalBasicInfo from '@/view/page/OrganizationManage/PersonalBasicInfo'

import BasicInfo from '@/view/fragment/MemberManage/BasicInfo'
import PBasicInfo from '@/view/fragment/personalManage/BasicInfo'

import IntegralInfo from '@/view/fragment/MemberManage/IntegralInfo'

import TaskInfo from '@/view/fragment/MemberManage/TaskInfo'

import ImportInfo from '@/view/fragment/MemberManage/ImportInfo'

import AuthData from '@/view/fragment/MemberManage/AuthData'

import CardInfo from '@/view/fragment/MemberManage/CardInfo'
import pCardInfo from '@/view/fragment/personalManage/CardInfo'

import FundsDetail from '@/view/fragment/MemberManage/FundsDetail'

import BalanceDetail from '@/view/fragment/MemberManage/BalanceDetail'

import FriendInfo from '@/view/fragment/MemberManage/FriendInfo'

import ZhifuCertification from '@/view/fragment/MemberManage/ZhifuCertification'
import MemRepayment from '@/view/fragment/MemberManage/Repayment'

import GraphStatistics from '@/view/page/StatisticsManage/GraphStatistics'
import topchart from '@/view/page/Welcome_chart'
import QuickTrading from '@/view/fragment/MemberManage/QuickTrading'


import RongBaoRegister from '@/view/page/RongBaoManage/RongBaoRegister'

import RongBaoBind from '@/view/page/RongBaoManage/RongBaoBind'

import ManualPayment from '@/view/page/TransactionManage/ManualPayment'

import TestimonyData from '@/view/page/ToolsManage/TestimonyData'

import TestimoneyDetails from '@/view/page/ToolsManage/TestimoneyDetails'

import IndexNoticeManage from '@/view/page/OrganizationManage/IndexNoticeManage'


// 办卡记录查询
import TatBankProfit from '@/view/page/CreditCardManage/TatBankProfit'


// 财务扣税记录
import TaxLog from '@/view/page/FinanceManage/TaxLog'
import TaxLogConfig from '@/view/page/FinanceManage/TaxLogConfig'
import TaxMemConfig from '@/view/page/FinanceManage/TaxMemConfig'
import TaxLogPerson from '@/view/page/FinanceManage/TaxLogPerson'
import FinancialReconciliation from '@/view/page/FinanceManage/FinancialReconciliation'


import SetPublicPlatoon from '@/view/page/OrganizationManage/SetPublicPlatoon'
import SetPublicPlatoonPage from '@/view/page/OrganizationManage/SetPublicPlatoonPage'


import PublicPlatoon from '@/view/page/OrganizationManage/PublicPlatoon'
import PublicPreLicensing from '@/view/page/OrganizationManage/PublicPreLicensing'
import PublicPreLicensingNew from '@/view/page/OrganizationManage/PublicPreLicensingNew'

import UpLevelRecord from '@/view/page/FinanceManage/UpLevelRecord'
import OrganManageGoods from '@/view/page/MallManage/OrganManageGoods'
import PublicPlatoonGoods from '@/view/page/MallManage/PublicPlatoonGoods'
import RebateWallet from '@/view/page/FinanceManage/RebateWallet'

// App管理
import MultiShare from '@/view/page/AppManager/MultiShare'
import MultiShareUpdate from '@/view/page/AppManager/MultiShareUpdate'
import PlatformIntroductionEdit from '@/view/page/AppManager/PlatformIntroductionEdit'
import OperationVideo from '@/view/page/AppManager/OperationVideo'
import OperationVideoUpdate from '@/view/page/AppManager/OperationVideoUpdate'
import ActivityNoticeManage from '@/view/page/AppManager/ActivityNoticeManage'
import HelpCenter from '@/view/page/AppManager/HelpCenter'
import RotationBanner from '@/view/page/AppManager/RotationBanner'
import Rotation from '@/view/page/AppManager/Rotation'
import RouletteLottery from '@/view/page/AppManager/RouletteLottery'
import RouletteLotteryFalse from '@/view/page/AppManager/RouletteLotteryFalse'
import ConfigurePrizes from '@/view/page/AppManager/ConfigurePrizes'
import ConfigurePrizesFalse from '@/view/page/AppManager/ConfigurePrizesFalse'
import UserLuckdrawInfo from '@/view/page/AppManager/UserLuckdrawInfo'
import StyleDisplay from '@/view/page/AppManager/StyleDisplay'
import MerchantLevelManage from '@/view/page/AppManager/MerchantLevelManage'
import MerchantUpgradeInfo from '@/view/page/AppManager/MerchantUpgradeInfo'


// App商户端管理
import AppPointsDetails from '@/view/page/AppManager/AppPointsDetails'
import XJAppPointsDetails from '@/view/page/AppManager/XJAppPointsDetails'
import AppPointsShopManage from '@/view/page/AppManager/AppPointsShopManage'
import AppPointsOrderQuery from '@/view/page/AppManager/AppPointsOrderQuery'
import AppPointsNewOdeToJoyManage from '@/view/page/AppManager/AppPointsNewOdeToJoyManage'
import AppPointsNewOdeToJoyInfo from '@/view/page/AppManager/AppPointsNewOdeToJoyInfo'
import AppBussiness from '@/view/page/AppManager/AppBussiness'
import AppPointsNewOdeToJoyInfoLook from '@/view/page/AppManager/AppPointsNewOdeToJoyInfoLook'
import YsPosAppPointsNewOdeToJoyManage from '@/view/page/AppManager/YsPosAppPointsNewOdeToJoyManage'
import YsPosAppPointsNewOdeToJoyInfo from '@/view/page/AppManager/YsPosAppPointsNewOdeToJoyInfo'
import YsPosAppPointsNewOdeToJoyInfoLook from '@/view/page/AppManager/YsPosAppPointsNewOdeToJoyInfoLook'
import VipAppPointsNewOdeToJoyManage from '@/view/page/AppManager/VipAppPointsNewOdeToJoyManage'
import VipAppPointsNewOdeToJoyInfo from '@/view/page/AppManager/VipAppPointsNewOdeToJoyInfo'
import VipAppPointsNewOdeToJoyInfoLook from '@/view/page/AppManager/VipAppPointsNewOdeToJoyInfoLook'
import AppPointsTransactionManage from '@/view/page/AppManager/AppPointsTransactionManage'
import MerchantGrowthFundDetails from '@/view/page/AppManager/MerchantGrowthFundDetails'
import AppPointsAgentOperations from '@/view/page/AppManager/AppPointsAgentOperations'
import CouponManage from '@/view/page/AppManager/CouponManage'
import CouponGroupManage from '@/view/page/AppManager/CouponGroupManage'
import CouponInfo from '@/view/page/AppManager/CouponInfo'
import CouponMerchantSelect from '@/view/page/AppManager/CouponMerchantSelect'
import AppPointsSign from '@/view/page/AppManager/AppPointsSign'
import AppPointsSignInfo from '@/view/page/AppManager/AppPointsSignInfo'
import TwoAppPointsNewOdeToJoyManage from '@/view/page/AppManager/TwoAppPointsNewOdeToJoyManage'
import TwoAppPointsNewOdeToJoyInfo from '@/view/page/AppManager/TwoAppPointsNewOdeToJoyInfo'
import TwoAppPointsNewOdeToJoyInfoLook from '@/view/page/AppManager/TwoAppPointsNewOdeToJoyInfoLook'
import TwoVipAppPointsNewOdeToJoyManage from '@/view/page/AppManager/TwoVipAppPointsNewOdeToJoyManage'
import TwoVipAppPointsNewOdeToJoyInfo from '@/view/page/AppManager/TwoVipAppPointsNewOdeToJoyInfo'
import TwoVipAppPointsNewOdeToJoyInfoLook from '@/view/page/AppManager/TwoVipAppPointsNewOdeToJoyInfoLook'
import ThreeAppPointsNewOdeToJoyManage from '@/view/page/AppManager/ThreeAppPointsNewOdeToJoyManage'
import ThteeAppPointsNewOdeToJoyInfo from '@/view/page/AppManager/ThteeAppPointsNewOdeToJoyInfo'
import ThreeAppPointsNewOdeToJoyInfoLook from '@/view/page/AppManager/ThreeAppPointsNewOdeToJoyInfoLook'
import ThreeVipAppPointsNewOdeToJoyInfo from '@/view/page/AppManager/ThreeVipAppPointsNewOdeToJoyInfo'
import ThreeVipAppPointsNewOdeToJoyInfoLook from '@/view/page/AppManager/ThreeVipAppPointsNewOdeToJoyInfoLook'
import ThreeVipAppPointsNewOdeToJoyManage from '@/view/page/AppManager/ThreeVipAppPointsNewOdeToJoyManage'
import LeyinGoldConfiguration from '@/view/page/AppManager/LeyinGoldConfiguration'
import LKLExamine from '@/view/page/AppManager/LKLExamine'
import LKLExamineDetail from '@/view/page/AppManager/LKLExamineDetail'
import LKLExamineDetailList from '@/view/page/AppManager/LKLExamineDetailList'
import LKLAppPointsNewOdeToJoyManage from '@/view/page/AppManager/LKLAppPointsNewOdeToJoyManage'
import LKLAppPointsNewOdeToJoyInfo from '@/view/page/AppManager/LKLAppPointsNewOdeToJoyInfo'
import LKLAppPointsNewOdeToJoyInfoLook from '@/view/page/AppManager/LKLAppPointsNewOdeToJoyInfoLook'
import DepositQuantityStatistics from '@/view/page/AppManager/DepositQuantityStatistics'

//机具管理
import PosManage from '@/view/page/PosImplement/PosManage'
import PosTransferInfo from '@/view/page/PosImplement/PosTransferInfo'
import PosRate from '@/view/page/PosImplement/PosRate'
import PosRateManage from '@/view/page/PosImplement/PosRateManage'
import PosGather from '@/view/page/PosImplement/PosGather'
import CodePlateRateManage from '@/view/page/PosImplement/CodePlateRateManage'
import CodePlateRateInfo from '@/view/page/PosImplement/CodePlateRateInfo'
import YsPosCodePlateRateManage from '@/view/page/PosImplement/YsPosCodePlateRateManage'
import YsPosCodePlateRateInfo from '@/view/page/PosImplement/YsPosCodePlateRateInfo'

//交易管理
import TransactionManage from '@/view/page/Transaction/TransactionManage'
import TransactionManageTwo from '@/view/page/Transaction/TransactionManageTwo'
import AgentShare from '@/view/page/Transaction/AgentShare'
import PointsDetails from '@/view/page/Transaction/PointsDetails'
import HappyReturnManage from '@/view/page/Transaction/HappyReturnManage'
import TwoHappyReturnManage from '@/view/page/Transaction/TwoHappyReturnManage'
import ThreeHappyReturnManage from '@/view/page/Transaction/ThreeHappyReturnManage'
import DetailedHappyReturn from '@/view/page/Transaction/DetailedHappyReturn'
import TwoDetailedHappyReturn from '@/view/page/Transaction/TwoDetailedHappyReturn'
import ThreeDetailedHappyReturn from '@/view/page/Transaction/ThreeDetailedHappyReturn'

import ActiveReentryManage from '@/view/page/Transaction/ActiveReentryManage'
import ActiveReentryInfo from '@/view/page/Transaction/ActiveReentryInfo'
import TeamRewardsManage from '@/view/page/Transaction/TeamRewardsManage'

import TeamCompliance from '@/view/page/Transaction/TeamCompliance'
import ReceiveDetail from '@/view/page/Transaction/ReceiveDetail'
import TeamExcellenceManage from '@/view/page/Transaction/TeamExcellenceManage'
import MerchantActivationManage from '@/view/page/Transaction/MerchantActivationManage'
import MerchantActivationExamine from '@/view/page/Transaction/MerchantActivationExamine'

//商城管理
import ShopManage from '@/view/page/ShopManagement/ShopManage'
import OrderQuery from '@/view/page/ShopManagement/OrderQuery'
import LogisticsInfo from '@/view/page/ShopManagement/LogisticsInfo'
import ShopPayment from '@/view/page/ShopManagement/ShopPayment'
import ShopCollection from '@/view/page/ShopManagement/ShopCollection'
import GiftPackManage from '@/view/page/ShopManagement/GiftPackManage'
import GiftPackageDetails from '@/view/page/ShopManagement/GiftPackageDetails'
import GiftPackageInfo from '@/view/page/ShopManagement/GiftPackageInfo'
import GDManage from '@/view/page/ShopManagement/GDManage'

//统计管理
import DirTeamTransaction from '@/view/page/Statistics/DirTeamTransaction'
import AllTransaction from '@/view/page/Statistics/AllTransaction'
import TeamTransaction from '@/view/page/Statistics/TeamTransaction'
import ShopTransactionTj from '@/view/page/Statistics/ShopTransactionTj'
import ShopVolumeTj from '@/view/page/Statistics/ShopVolumeTj'
import ShopVolumeTjTwo from '@/view/page/Statistics/ShopVolumeTjTwo'
import AgentVolumeTj from '@/view/page/Statistics/AgentVolumeTj'
import ShopActivationLook from '@/view/page/Statistics/ShopActivationLook'
import RevenueStatistics from '@/view/page/Statistics/RevenueStatistics'
import EcBarGraph from '@/view/page/Statistics/EcBarGraph'
import EcPie from '@/view/page/Statistics/EcPie'
import EcLineChart from '@/view/page/Statistics/EcLineChart'
import EcAgeLineChart from '@/view/page/Statistics/EcAgeLineChart'
import MerchantEcPie from '@/view/page/Statistics/MerchantEcPie'
import MerchantEcLineChart from '@/view/page/Statistics/MerchantEcLineChart'
import MerchantEcAgeLineChart from '@/view/page/Statistics/MerchantEcAgeLineChart'

//网申卡管理
import OnlineApplicationCardResources from '@/view/page/OnlineApplicationCard/OnlineApplicationCardResources'
import OnlineApplicationCardManage from '@/view/page/OnlineApplicationCard/OnlineApplicationCardManage'
import MerOnlineApplicationCardManage from '@/view/page/OnlineApplicationCard/MerOnlineApplicationCardManage'
import OnlineCardResult from '@/view/page/OnlineApplicationCard/OnlineCardResult'
import OnlineCard from '@/view/page/OnlineApplicationCard/OnlineCard'
//排行榜管理
import RankIngManage from '@/view/page/RankIng/RankIngManage'
import MonthlyList from '@/view/page/RankIng/MonthlyList'
import WeekList from '@/view/page/RankIng/WeekList'
import IntegralList from '@/view/page/RankIng/IntegralList'
import RewardList from '@/view/page/RankIng/RewardList'

//新排行榜管理
import NewRankIngManage from '@/view/page/NewRankIng/NewRankIngManage'
import NewMonthlyList from '@/view/page/NewRankIng/NewMonthlyList'
import NewIntegralList from '@/view/page/NewRankIng/NewIntegralList'
import NewRewardList from '@/view/page/NewRankIng/NewRewardList'

//富有管理
import MerchantAccess from '@/view/page/Rich/MerchantAccess'
import PersonalUser from '@/view/page/OrganizationManage/PersonalUser'
import PersonalMerchant from '@/view/page/OrganizationManage/PersonalMerchant'
// POSP管理
import merchantSupplierManagement from '@/view/page/POSPmanage/merchantSupplierManagement'
// 易生管理
import AyiSheng from '@/view/page/AyiShengFile/AyiSheng'
import AyiShengChild from '@/view/page/AyiShengFile/AyiShengChild' 
import AyiShengMoney from '@/view/page/AyiShengFile/AyiShengMoney' 
// 通道管理
import channelMerchant from '@/view/page/POSPmanage/channelMerchant'
// 通道管理
import POSPTerminalManagement from '@/view/page/POSPTerminalManagement/POSPTerminalManagement'
// 通道终端
import ChannelTerminal from '@/view/page/POSPTerminalManagement/ChannelTerminal'
Vue.use(Router);
export default new Router({
    // mode: 'history',
    routes: [
        {
            path: '/',
            redirect: '/login',
        },
        {
            path: '/login',
            name: 'Login',
            component: Login,
        },
        {
            path: '/index',
            name: 'Index',
            component: Index,
            redirect: '/index/welcome',
            children: [
                {
                    path: 'welcome',
                    name: 'Welcome',
                    component: Welcome
                },
                {
                    path: 'organmanage',
                    name: 'organmanage',
                    component: OrganManage,
                    meta: {
                        name: '机构管理-机构管理'
                    }
                },
                {
                    path: 'organmanage/addorganmanage/:id?',
                    name: 'addorganmanage',
                    component: AddOrganManage,
                    meta: {
                        name: '机构管理-机构管理-基础配置'
                    }
                },
                {
                    path: 'organmanage/organmanageparams/:item',
                    name: 'organmanageparams',
                    component: OrganManageParams,
                    meta: {
                        name: '机构管理-机构管理-参数配置'
                    }
                },

                {
                    path: 'levelpublicplatoontest',
                    name: 'levelpublicplatoontest',
                    component: LevelPublicPlatoonTest,
                    meta: {
                        keepAlive: true,
                    },
                },
                {
                    path: 'levelpublicplatoon',
                    name: 'levelpublicplatoon',
                    component: LevelPublicPlatoon,
                    meta: {
                        keepAlive: true,
                    },
                },
                {
                    path: 'levelpublicprelicensing',
                    name: 'levelpublicprelicensing',
                    component: LevelPublicPreLicensing
                },
                {
                    path: 'indexnoticemanage',
                    name: 'indexnoticemanage',
                    component: IndexNoticeManage,
                    meta: {
                        name: '机构管理-系统消息管理'
                    }
                },
                {
                    path: 'memberchannelrank',
                    name: 'memberchannelrank',
                    component: MemberChannelRank,
                    meta: {
                        name: '机构管理-机构会员费率管理'
                    }
                },


                {
                    path: 'implementInfo/:item',
                    name: 'implementInfo',
                    component: ImplementInfo
                },
                {
                    path: 'merchantInfo/:item',
                    name: 'merchantInfo',
                    component: MerchantInfo
                },
                {
                    path: 'organblack',
                    name: 'organblack',
                    component: OrganBlack,
                    meta: {
                        name: '机构管理-机构黑名单管理'
                    }
                },
                {
                    path: 'organrate',
                    name: 'organrate',
                    component: OrganRate,
                    meta: {
                        name: '机构管理-机构费率管理'
                    }
                },
                {
                    path: 'organrate/addorganrate/:id?',
                    name: 'addorganrate',
                    component: AddOrganRate,
                    meta: {
                        name: '机构管理-机构费率管理-添加/修改'
                    }
                },
                {
                    path: 'organnote',
                    name: 'organnote',
                    component: OrganNote,
                    meta: {
                        name: '机构管理-机构短信管理'
                    }
                },
                {
                    path: 'organcertification',
                    name: 'organcertification',
                    component: OrganCertification,
                    meta: {
                        name: '机构管理-机构实名认证管理'
                    }
                },
                {
                    path: 'cashmanage',
                    name: 'cashmanage',
                    component: CashManage,
                    meta: {
                        name: '机构管理-机构提现管理'
                    }
                },
                {
                    path: 'paymanage',
                    name: 'paymanage',
                    component: PayManage,
                    meta: {
                        name: '机构管理-机构缴费管理'
                    }
                },
                {
                    path: 'refundmanage',
                    name: 'refundmanage',
                    component: RefundManage,
                    meta: {
                        name: '机构管理-机构退款管理'
                    },
                }, {
                    path: 'refundmanageinner/:info?/:flag',
                    name: 'refundmanageinner',
                    component: RefundManageInner,
                },
                {
                    path: 'onlineapplicationcard',
                    name: 'onlineapplicationcard',
                    component: OnlineApplicationCard,
                    meta: {
                        name: '机构管理-网申卡分润比例'
                    }
                },
                {
                    path: 'cardevaluation',
                    name: 'cardevaluation',
                    component: CardEvaluation,
                    meta: {
                        name: '机构管理-卡测评管理'
                    }
                },
                {
                    path: 'appareamanage',
                    name: 'appareamanage',
                    component: AppAreaManage,
                    meta: {
                        name: '机构管理-应用位置管理'
                    }
                },
                {
                    path: 'appupload/:id?',
                    name: 'appupload',
                    component: AppUpload,
                    meta: {
                        name: '机构管理-应用位置管理-添加'
                    }
                },
                {
                    path: 'appareadetail/:tatSimpleId/:os',
                    name: 'appareadetail',
                    component: AppAreaDetail,
                    meta: {
                        name: '机构管理-应用位置管理-详情'
                    }
                },
                {
                    path: 'setpublicplatoon/:item',
                    name: 'setpublicplatoon',
                    component: SetPublicPlatoon,
                    meta: {
                        name: '机构管理-机构公排管理'
                    }
                },
                {
                    path: 'setpublicplatoonpage',
                    name: 'setpublicplatoonpage',
                    component: SetPublicPlatoonPage,
                    meta: {
                        name: '机构管理-机构公排管理-详情'
                    }
                },
                {
                    path: 'publicplatoon',
                    name: 'publicplatoon',
                    component: PublicPlatoon,
                    meta: {
                        name: '机构管理-机构公排明细'
                    }
                },
                {
                    path: 'publicprelicensing',
                    name: 'publicprelicensing',
                    component: PublicPreLicensing,
                    meta: {
                        name: '机构管理-机构公排在途明细-后期作废'
                    }
                },
                {
                    path: 'publicprelicensingnew',
                    name: 'publicprelicensingnew',
                    component: PublicPreLicensingNew,
                    meta: {
                        name: '机构管理-机构公排在途明细-新页面对比'
                    }
                },
                {
                    path: 'uplevelrecord',
                    name: 'uplevelrecord',
                    component: UpLevelRecord,
                    meta: {
                        name: '机构管理-卓越升级记录'
                    }
                },
                {
                    path: 'memberbasicinfo/:id/:simpleTatId',
                    name: 'memberbasicinfo',
                    component: MemberBasicInfo,
                    redirect: 'memberbasicinfo/:id/:simpleTatId/basicinfo',
                    meta: {
                        name: '机构管理-机构会员管理-会员详情'
                    },
                    children: [{
                        path: 'basicinfo',
                        name: 'basicinfo',
                        component: BasicInfo
                    }, {
                        path: 'fundsdetail',
                        name: 'fundsdetail',
                        component: FundsDetail
                    }, {
                        path: 'integralinfo',
                        name: 'integralinfo',
                        component: IntegralInfo
                    }, {
                        path: 'taskinfo',
                        name: 'taskinfo',
                        component: TaskInfo
                    }, {
                        path: 'importinfo',
                        name: 'importinfo',
                        component: ImportInfo
                    }, {
                        path: 'certification',
                        name: 'certification',
                        component: Certification
                    }, {
                        path: 'authdata',
                        name: 'authdata',
                        component: AuthData
                    }, {
                        path: 'cardinfo',
                        name: 'cardinfo',
                        component: CardInfo
                    }, {
                        path: 'friendinfo',
                        name: 'friendinfo',
                        component: FriendInfo
                    }, {
                        path: 'zhifucertification',
                        name: 'zhifucertification',
                        component: ZhifuCertification
                    }, {
                        path: 'balancedetail',
                        name: 'balancedetail',
                        component: BalanceDetail
                    }, {
                        path: 'memrepayment',
                        name: 'memrepayment',
                        component: MemRepayment
                    }, {
                        path: 'quicktrading',
                        name: 'quicktrading',
                        component: QuickTrading
                    },]
                },
                {
                    path: 'memberselecttwo',
                    name: 'memberselecttwo',
                    component: MemberSelectTwo,
                },
                {
                    path: 'channelrate/customconfiguration/:info/:flag',
                    name: 'customconfiguration',
                    component: CustomConfiguration
                },
                {
                    path: 'changechannelmanage',
                    name: 'changechannelmanage',
                    component: ChangeChannelManage
                },
                {
                    path: 'emptycashplandetails/:item',
                    name: 'emptycashplandetails',
                    component: EmptyCashPlanDetails
                },
                {
                    path: 'plandetails/:id',
                    name: 'plandetails',
                    component: PlanDetails
                },
                {
                    path: 'repaymentdetails/:id/:tranType',
                    name: 'tranrepaymentdetails',
                    component: RepaymentDetails,
                },
                {
                    path: 'repaymentdetails/:id',
                    name: 'repaymentdetails',
                    component: RepaymentDetails
                },
                {
                    path: 'twopublicplatoon',
                    name: 'twopublicplatoon',
                    component: TwoPublicPlatoon,
                },
                {
                    path: 'dandeliondotsort',
                    name: 'dandeliondotsort',
                    component: DandelionDotSort,
                },
                {
                    path: 'hbcollection',
                    name: 'hbcollection',
                    component: HBCollection,
                    meta: {
                        keepAlive: true,
                    },
                },
                {
                    path: 'message',
                    name: 'message',
                    component: Message
                },
                {
                    path: 'creditcard',
                    name: 'creditcard',
                    component: CreditCard
                },
                {
                    path: 'historyuplevel',
                    name: 'historyuplevel',
                    component: HistoryUPLevel
                },
                {
                    path: 'accountmanage',
                    name: 'accountmanage',
                    component: AccountManage
                },
                {
                    path: 'offlinepaymentreview',
                    name: 'offlinepaymentreview',
                    component: OfflinePaymentReview
                },
                {
                    path: 'offlineQRcode',
                    name: 'offlineQRcode',
                    component: OfflineQRCode
                },
                {
                    path: 'withdrawalreview',
                    name: 'withdrawalreview',
                    component: WithdrawalReview
                },
                {
                    path: 'connectwithdrawalreview',
                    name: 'connectwithdrawalreview',
                    component: ConnectWithdrawalReview
                },
                {
                    path: 'privatecashout',
                    name: 'privatecashout',
                    component: PrivateCashOut
                },
                {
                    path: 'resultonlinecard',
                    name: 'resultonlinecard',
                    component: ResultOnlineCard
                },
                {
                    path: 'accountadjustmentdetail',
                    name: 'accountadjustmentdetail',
                    component: AccountAdjustmentDetail
                },
                {
                    path: 'settlementdetail',
                    name: 'settlementdetail',
                    component: SettlementDetail
                },
                {
                    path: 'outaccountdetail',
                    name: 'outaccountdetail',
                    component: OutAccountDetail
                },
                {
                    path: 'platformaccountdetails',
                    name: 'repaymentdetail',
                    component: RepaymentDetail
                },
                {
                    path: 'newawarddetail',
                    name: 'newawarddetail',
                    component: NewAwardDetail
                },
                {
                    path: 'receivedetailnew',
                    name: 'receivedetailnew',
                    component: ReceiveDetailNew
                },
                {
                    path: 'inventeddetail',
                    name: 'inventeddetail',
                    component: InventedDetail
                },
                {
                    path: 'inventeddetailnew',
                    name: 'inventeddetailnew',
                    component: InventedDetailNew
                },
                {
                    path: 'inventedrewarddetail',
                    name: 'inventedrewarddetail',
                    component: InventedRewardDetail
                },
                {
                    path: 'inventedrewarddetailnew',
                    name: 'inventedrewarddetailnew',
                    component: InventedRewardDetailNew
                },

                {
                    path: 'settlemanage/memberleveldetail/:id',
                    name: 'settlememberleveldetail',
                    component: MemberLevelDetail
                },
                {
                    path: 'memberaccountdetail',
                    name: 'memberaccountdetail',
                    component: MemberAccountDetail
                },
                {
                    path: 'memberleveldetail/:id',
                    name: 'memberleveldetail',
                    component: MemberLevelDetail
                },
                {
                    path: 'catchmanage',
                    name: 'catchmanage',
                    component: CatchManage
                },
                {
                    path: 'catchmanage/memberleveldetail/:id',
                    name: 'catchmemberleveldetail',
                    component: MemberLevelDetail
                },
                {
                    path: 'platformassets',
                    name: 'platformassets',
                    component: PlatformAssets
                },
                {
                    path: 'servicemanage',
                    name: 'servicemanage',
                    component: ServiceManage
                },
                {
                    path: 'dailystatistics',
                    name: 'dailystatistics',
                    component: DailyStatistics
                },
                {
                    path: 'graphstatistics',
                    name: 'graphstatistics',
                    component: GraphStatistics
                },
                {
                    path: 'topchart',
                    name: 'topchart',
                    component: topchart
                },
                {
                    path: 'withdrawal',
                    name: 'withdrawal',
                    component: Withdrawal
                },
                {
                    path: 'organprofitstatistics',
                    name: 'organprofitstatistics',
                    component: OrganProfitStatistics
                },
                {
                    path: 'chnplanstatistics',
                    name: 'chnplanstatistics',
                    component: ChnPlanStatistics
                },
                //系统管理模块
                {
                    path: 'selectmanage',
                    name: 'selectmanage',
                    component: SelectManage
                },
                {
                    path: 'dictionarymanage',
                    name: 'dictionarymanage',
                    component: DictionaryManage
                },
                {
                    path: 'systempropmanage',
                    name: 'systempropmanage',
                    component: SystemPropertiesManage
                },
                {
                    path: 'broker',
                    name: 'broker',
                    component: Broker
                },
                {
                    path: 'businesses',
                    name: 'businesses',
                    component: Businesses
                },
                {
                    path: 'peopeizhi',
                    name: 'peopeizhi',
                    component: peopeizhi
                },
                {
                    path: 'systempropertiesconfig',
                    name: 'systempropertiesconfig',
                    component: SystemPropertiesConfig
                },
                {
                    path: 'smswarning',
                    name: 'smswarning',
                    component: SmsWarning
                },
                {
                    path: 'channelnotesend',
                    name: 'channelnotesend',
                    component: ChannelNoteSend,
                },
                {
                    path: 'channelnotesend/pushinfo/:id/:pushRange',
                    name: 'pushinfo',
                    component: PushInfo,
                },
                {
                    path: 'usermanage',
                    name: 'usermanage',
                    component: UserManage
                },
                {
                    path: 'rolemanage',
                    name: 'rolemanage',
                    component: RoleManage
                },
                {
                    path: 'menumanage',
                    name: 'menumanage',
                    component: MenuManage
                },
                {
                    path: 'otherservice',
                    name: 'otherservice',
                    component: OtherService
                },
                {
                    path: 'rongbaoregister',
                    name: 'rongbaoregister',
                    component: RongBaoRegister
                },
                {
                    path: 'rongbaobind',
                    name: 'rongbaobind',
                    component: RongBaoBind
                },
                {
                    path: 'manualpayment',
                    name: 'manualpayment',
                    component: ManualPayment,
                    meta: {
                        keepAlive: true,
                    }
                },
                {
                    path: 'testimonydata',
                    name: 'testimonydata',
                    component: TestimonyData,
                }, {
                    path: 'testimoneydetails/:id/:name?/:phone?',
                    name: 'testimoneydetails',
                    component: TestimoneyDetails
                },
                {
                    path: 'tatbankaprofit',
                    name: 'tatbankaprofit',
                    component: TatBankProfit
                },
                {
                    path: 'taxlog',
                    name: 'taxlog',
                    component: TaxLog
                },
                {
                    path: 'taxlogperson',
                    name: 'taxlogperson',
                    component: TaxLogPerson
                },
                {
                    path: 'financialreconciliation',
                    name: 'financialreconciliation',
                    component: FinancialReconciliation
                },
                {
                    path: 'taxlogconfig',
                    name: 'taxlogconfig',
                    component: TaxLogConfig
                },
                {
                    path: 'taxmemconfig/:item',
                    name: 'taxmemconfig',
                    component: TaxMemConfig
                },
                {
                    path: 'organmanagegoods/:item',
                    name: 'organmanagegoods',
                    component: OrganManageGoods
                },
                {
                    path: 'publicplatoongoods/:item',
                    name: 'publicplatoongoods',
                    component: PublicPlatoonGoods
                },
                {
                    path: 'rebatewallet',
                    name: 'rebatewallet',
                    component: RebateWallet
                },
                // 用户管理模块商户管理
                {
                    path: 'personaluser',
                    name: 'personaluser',
                    component: PersonalUser,
                },
                {
                    path: 'personalbasicinfo/:id',
                    name: 'personalbasicinfo',
                    component: PersonalBasicInfo,
                    redirect: 'personalbasicinfo/:id/pbasicinfo',
                    meta: {
                        name: '个人版-用户管理-会员详情'
                    },
                    children: [{
                        path: 'pbasicinfo',
                        name: 'pbasicinfo',
                        component: PBasicInfo
                    }, {
                        path: 'pcardinfo',
                        name: 'pcardinfo',
                        component: pCardInfo
                    }]
                },
                {
                    path: 'personalmerchant',
                    name: 'personalmerchant',
                    component: PersonalMerchant,
                },
                {
                    path: 'organuser',
                    name: 'organuser',
                    component: OrganUser,
                },
                {
                    path: 'aamerchantrates',
                    name: 'aamerchantrates',
                    component: AAmerchantrates,
                },
                {
                    path: 'aamerchantmange',
                    name: 'aamerchantmange',
                    component: AAmerchantMange,
                },
                {
                    path: 'copymerchantInfo',
                    name: 'copymerchantInfo',
                    component: CopyMerchantInfo
                },
                {
                    path: 'copymerchantInfoManage/:item',
                    name: 'copymerchantInfoManage',
                    component: CopyMerchantInfoManage
                },
                {
                    path: 'copymerchantInfoFeilv/:item',
                    name: 'copymerchantInfoFeilv',
                    component: CopyMerchantInfoFeilv
                },
                {
                    path: 'memberupgrade',
                    name: 'memberupgrade',
                    component: MemberUpgrade,
                },
                {
                    path: 'settlemanage',
                    name: 'settlemanage',
                    component: SettleManage,
                    meta: {
                        keepAlive: true
                    },
                },
                {
                    path: 'partnerlevelmanage',
                    name: 'partnerlevelmanage',
                    component: PartnerLevelManage,
                },
                {
                    path: 'partnerlevelinfo',
                    name: 'partnerlevelinfo',
                    component: PartnerLevelInfo,
                },
                {
                    path: 'partnerlookinfo',
                    name: 'partnerlookinfo',
                    component: PartnerLookInfo,
                },
                {
                    path: 'upgradeassessment',
                    name: 'upgradeassessment',
                    component: UpgradeAssessment,
                },
                {
                    path: 'agentperformance',
                    name: 'agentperformance',
                    component: AgentPerformance,
                },
                {
                    path: 'agentperformancedetails/:item',
                    name: 'agentperformancedetails',
                    component: AgentPerformanceDetails
                },
                {
                    path: 'identitymanage',
                    name: 'identitymanage',
                    component: IdentityManage,
                },
                {
                    path: 'accountsupervise',
                    name: 'accountsupervise',
                    component: AccountSupervise,
                },
                {
                    path: 'merchantevaluation',
                    name: 'merchantevaluation',
                    component: MerchantEvaluation,
                },
                {
                    path: 'cloudflashpayment',
                    name: 'cloudflashpayment',
                    component: CloudFlashPayment,
                },
                // App商户端
                {
                    path: 'apppointsdetails',
                    name: 'apppointsdetails',
                    component: AppPointsDetails,
                },
                {
                    path: 'xjapppointsdetails',
                    name: 'xjapppointsdetails',
                    component: XJAppPointsDetails,
                },
                {
                    path: 'apppointsshopmanage',
                    name: 'apppointsshopmanage',
                    component: AppPointsShopManage,
                },
                {
                    path: 'apppointsorderquery',
                    name: 'apppointsorderquery',
                    component: AppPointsOrderQuery,
                },
                {
                    path: 'apppointsnewodetojoymanage',
                    name: 'apppointsnewodetojoymanage',
                    component: AppPointsNewOdeToJoyManage,
                },
                {
                    path: 'apppointsnewodetoJoyinfo',
                    name: 'apppointsnewodetoJoyinfo',
                    component: AppPointsNewOdeToJoyInfo,
                },
                {
                    path: 'appbussiness',
                    name: 'appbussiness',
                    component: AppBussiness,
                },
                
                {
                    path: 'apppointsnewodetoJoyinfolook/:item',
                    name: 'apppointsnewodetoJoyinfolook',
                    component: AppPointsNewOdeToJoyInfoLook
                },
                {
                    path: 'ysposapppointsnewodetojoymanage',
                    name: 'ysposapppointsnewodetojoymanage',
                    component: YsPosAppPointsNewOdeToJoyManage,
                },
                {
                    path: 'ysposapppointsnewodetoJoyinfo',
                    name: 'ysposapppointsnewodetoJoyinfo',
                    component: YsPosAppPointsNewOdeToJoyInfo,
                },
                {
                    path: 'ysposapppointsnewodetoJoyinfolook/:item',
                    name: 'ysposapppointsnewodetoJoyinfolook',
                    component: YsPosAppPointsNewOdeToJoyInfoLook
                },
                {
                    path: 'vipapppointsnewodetojoymanage',
                    name: 'vipapppointsnewodetojoymanage',
                    component: VipAppPointsNewOdeToJoyManage,
                },
                {
                    path: 'vipapppointsnewodetoJoyinfo',
                    name: 'vipapppointsnewodetoJoyinfo',
                    component: VipAppPointsNewOdeToJoyInfo,
                },
                {
                    path: 'vipapppointsnewodetoJoyinfolook/:item',
                    name: 'vipapppointsnewodetoJoyinfolook',
                    component: VipAppPointsNewOdeToJoyInfoLook
                },
                {
                    path: 'apppointstransactionmanage',
                    name: 'apppointstransactionmanage',
                    component: AppPointsTransactionManage
                },
                {
                    path: 'merchantgrowthfunddetails',
                    name: 'merchantgrowthfunddetails',
                    component: MerchantGrowthFundDetails
                },
                {
                    path: 'apppointsagentoperations',
                    name: 'apppointsagentoperations',
                    component: AppPointsAgentOperations
                },
                {   //优惠卷
                    path: 'couponmanage',
                    name: 'couponmanage',
                    component: CouponManage
                },
                {
                    path: 'coupongroupmanage',
                    name: 'coupongroupmanage',
                    component: CouponGroupManage
                },
                {
                    path: 'couponinfo',
                    name: 'couponinfo',
                    component: CouponInfo
                },
                {
                    path: 'couponmerchantselect',
                    name: 'couponmerchantselect',
                    component: CouponMerchantSelect
                },
                {
                    path: 'apppointssign',
                    name: 'apppointssign',
                    component: AppPointsSign
                },
                {
                    path: 'apppointssigninfo',
                    name: 'apppointssigninfo',
                    component: AppPointsSignInfo
                },
                {   //鼓励金2.0
                    path: 'twoapppointsnewodetojoymanage',
                    name: 'twoapppointsnewodetojoymanage',
                    component: TwoAppPointsNewOdeToJoyManage,
                },
                {   //鼓励金3.0
                    path: 'threeapppointsnewodetojoymanage',
                    name: 'threeapppointsnewodetojoymanage',
                    component: ThreeAppPointsNewOdeToJoyManage,
                },
                {
                    path: 'twoapppointsnewodetoJoyinfo',
                    name: 'twoapppointsnewodetoJoyinfo',
                    component: TwoAppPointsNewOdeToJoyInfo,
                },
                {
                    path: 'thteeapppointsnewodetojoyinfo',
                    name: 'thteeapppointsnewodetojoyinfo',
                    component: ThteeAppPointsNewOdeToJoyInfo,
                },
                {
                    path: 'twoapppointsnewodetoJoyinfolook/:item',
                    name: 'twoapppointsnewodetoJoyinfolook',
                    component: TwoAppPointsNewOdeToJoyInfoLook
                },
                {
                    path: 'threeapppointsnewodetojoyinfolook/:item',
                    name: 'threeapppointsnewodetojoyinfolook',
                    component: ThreeAppPointsNewOdeToJoyInfoLook
                },
                {
                    path: 'twovipapppointsnewodetojoymanage',
                    name: 'twovipapppointsnewodetojoymanage',
                    component: TwoVipAppPointsNewOdeToJoyManage,
                },
                {
                    path: 'threevipapppointsnewodetojoymanage',
                    name: 'threevipapppointsnewodetojoymanage',
                    component: ThreeVipAppPointsNewOdeToJoyManage,
                },
                {
                    path: 'twovipapppointsnewodetoJoyinfo',
                    name: 'twovipapppointsnewodetoJoyinfo',
                    component: TwoVipAppPointsNewOdeToJoyInfo,
                },
                {
                    path: 'threevipapppointsnewodetojoyinfo',
                    name: 'threevipapppointsnewodetojoyinfo',
                    component: ThreeVipAppPointsNewOdeToJoyInfo,
                },
                {
                    path: 'twovipapppointsnewodetoJoyinfolook/:item',
                    name: 'twovipapppointsnewodetoJoyinfolook',
                    component: TwoVipAppPointsNewOdeToJoyInfoLook
                },
                {
                    path: 'threevipapppointsnewodetojoyinfolook/:item',
                    name: 'threevipapppointsnewodetojoyinfolook',
                    component: ThreeVipAppPointsNewOdeToJoyInfoLook
                },
                {
                    path: 'leyingoldconfiguration',
                    name: 'leyingoldconfiguration',
                    component: LeyinGoldConfiguration
                },
                {
                    path: 'lklexamine',
                    name: 'lklexamine',
                    component: LKLExamine
                },
                {
                    path: 'lklexaminedetail',
                    name: 'lklexaminedetail',
                    component: LKLExamineDetail
                },
                {
                    path: 'lklexaminedetaillist/:pId',
                    name: 'lklexaminedetaillist',
                    component: LKLExamineDetailList
                },
                {
                    path: 'lklapppointsnewodetojoymanage',
                    name: 'lklapppointsnewodetojoymanage',
                    component: LKLAppPointsNewOdeToJoyManage
                },
                {
                    path: 'lklapppointsnewodetojoyinfo',
                    name: 'lklapppointsnewodetojoyinfo',
                    component: LKLAppPointsNewOdeToJoyInfo
                },
                {
                    path: 'lklapppointsnewodetojoyinfolook/:item',
                    name: 'lklapppointsnewodetojoyinfolook',
                    component: LKLAppPointsNewOdeToJoyInfoLook
                },
                {
                    path: 'depositquantitystatistics',
                    name: 'depositquantitystatistics',
                    component: DepositQuantityStatistics
                },
                //App
                {
                    path: 'multishare',
                    name: 'multishare',
                    component: MultiShare,
                },
                {
                    path: 'multishareupdate/:isHaved/:item?',
                    name: 'multishareupdate',
                    component: MultiShareUpdate,
                },
                {
                    path: 'platformintroductionedit/:item?/:fuID',
                    name: 'platformintroductionedit',
                    component: PlatformIntroductionEdit,
                },
                {
                    path: 'operationvideo',
                    name: 'operationvideo',
                    component: OperationVideo,
                },

                {
                    path: 'operationvideoupdate/:isHaved/:item?',
                    name: 'operationvideoupdate',
                    component: OperationVideoUpdate,
                },
                {
                    path: 'activitynoticemanage',
                    name: 'activitynoticemanage',
                    component: ActivityNoticeManage,
                },
                {
                    path: 'helpcenter',
                    name: 'helpcenter',
                    component: HelpCenter,
                },
                {
                    path: 'rotationbanner',
                    name: 'rotationbanner',
                    component: RotationBanner,
                },
                {
                    path: 'rotation/:item',
                    name: 'rotation',
                    component: Rotation,
                },
                {
                    path: 'roulettelottery',
                    name: 'roulettelottery',
                    component: RouletteLottery,
                },
                {
                    path: 'roulettelotteryfalse',
                    name: 'roulettelotteryfalse',
                    component: RouletteLotteryFalse,
                },
                {
                    path: 'configureprizes/:item',
                    name: 'configureprizes',
                    component: ConfigurePrizes,
                },
                {
                    path: 'configureprizesfalse/:item',
                    name: 'configureprizesfalse',
                    component: ConfigurePrizesFalse,
                },
                {
                    path: 'userluckdrawinfo',
                    name: 'userluckdrawinfo',
                    component: UserLuckdrawInfo,
                },
                {
                    path: 'styledisplay',
                    name: 'styledisplay',
                    component: StyleDisplay,
                },

                {// 商户等级管理
                    path: 'merchantlevelmanage',
                    name: 'merchantlevelmanage',
                    component: MerchantLevelManage,
                },
                {// 商户升级明细
                    path: 'merchantupgradeinfo',
                    name: 'merchantupgradeinfo',
                    component: MerchantUpgradeInfo,
                },

                //机具管理
                {
                    path: 'posmanage',
                    name: 'posmanage',
                    component: PosManage,
                },
                {
                    path: 'postransferinfo',
                    name: 'postransferinfo',
                    component: PosTransferInfo,
                },
                {
                    path: 'posrate',
                    name: 'posrate',
                    component: PosRate,
                },
                {
                    path: 'posratemanage/:item',
                    name: 'posratemanage',
                    component: PosRateManage
                },
                {
                    path: 'posgather',
                    name: 'posgather',
                    component: PosGather
                },
                {
                    path: 'codeplateratemanage',
                    name: 'codeplateratemanage',
                    component: CodePlateRateManage
                },
                {
                    path: 'codeplaterateinfo',
                    name: 'codeplaterateinfo',
                    component: CodePlateRateInfo
                },
                {
                    path: 'ysposcodeplateratemanage',
                    name: 'ysposcodeplateratemanage',
                    component: YsPosCodePlateRateManage
                },
                {
                    path: 'ysposcodeplaterateinfo',
                    name: 'ysposcodeplaterateinfo',
                    component: YsPosCodePlateRateInfo
                },


                //交易管理
                {
                    path: 'receivedetail',
                    name: 'receivedetail',
                    component: ReceiveDetail
                },
                {
                    path: 'transactionmanage',
                    name: 'transactionmanage',
                    component: TransactionManage,
                },
                {
                    path: 'transactionmanagetwo',
                    name: 'transactionmanagetwo',
                    component: TransactionManageTwo,
                },
                {
                    path: 'agentshare',
                    name: 'agentshare',
                    component: AgentShare,
                },
                {
                    path: 'pointsdetails',
                    name: 'pointsdetails',
                    component: PointsDetails,
                },
                {
                    path: 'happyreturnmanage',
                    name: 'happyreturnmanage',
                    component: HappyReturnManage,
                },
                {
                    path: 'twohappyreturnmanage',
                    name: 'twohappyreturnmanage',
                    component: TwoHappyReturnManage,
                },
                {
                    path: 'threehappyreturnmanage',
                    name: 'threehappyreturnmanage',
                    component: ThreeHappyReturnManage,
                },
                {
                    path: 'detailedhappyreturn',
                    name: 'detailedhappyreturn',
                    component: DetailedHappyReturn,
                },
                {
                    path: 'twodetailedhappyreturn',
                    name: 'twodetailedhappyreturn',
                    component: TwoDetailedHappyReturn,
                },
                {
                    path: 'threedetailedhappyreturn',
                    name: 'threedetailedhappyreturn',
                    component: ThreeDetailedHappyReturn,
                },
                {
                    path: 'activereentrymanage',
                    name: 'activereentrymanage',
                    component: ActiveReentryManage,
                },
                {
                    path: 'activereentryinfo',
                    name: 'activereentryinfo',
                    component: ActiveReentryInfo,
                },
                {
                    path: 'teamrewardsmanage',
                    name: 'teamrewardsmanage',
                    component: TeamRewardsManage,
                },
                {
                    path: 'teamcompliance',
                    name: 'teamcompliance',
                    component: TeamCompliance,
                },
                {
                    path: 'teamexcellencemanage',
                    name: 'teamexcellencemanage',
                    component: TeamExcellenceManage,
                },
                {
                    path: 'merchantactivationmanage',
                    name: 'merchantactivationmanage',
                    component: MerchantActivationManage,
                },
                {
                    path: 'merchantactivationexamine',
                    name: 'merchantactivationexamine',
                    component: MerchantActivationExamine,
                },

                //商城管理
                {
                    path: 'shopmanage',
                    name: 'shopmanage',
                    component: ShopManage,
                },
                {
                    path: 'orderquery',
                    name: 'orderquery',
                    component: OrderQuery
                },
                {
                    path: 'logisticsinfo/:logisticsinfoinfo?/:flag',
                    name: 'logisticsinfo',
                    component: LogisticsInfo,
                },
                {
                    path: 'shoppayment',
                    name: 'shoppayment',
                    component: ShopPayment,
                },
                {
                    path: 'shopcollection',
                    name: 'shopcollection',
                    component: ShopCollection,
                },
                {
                    path: 'giftpackmanage',
                    name: 'giftpackmanage',
                    component: GiftPackManage,
                },
                {
                    path: 'giftpackagedetails',
                    name: 'giftpackagedetails',
                    component: GiftPackageDetails,
                },
                {
                    path: 'giftpackageinfo',
                    name: 'giftpackageinfo',
                    component: GiftPackageInfo,
                },
                {
                    path: 'gdmanage',
                    name: 'gdmanage',
                    component: GDManage,
                },


                //统计管理
                {
                    path: 'teamtransaction',
                    name: 'teamtransaction',
                    component: TeamTransaction,
                },
                {
                    path: 'alltransaction',
                    name: 'alltransaction',
                    component: AllTransaction,
                },
                {
                    path: 'dirteamtransaction',
                    name: 'dirteamtransaction',
                    component: DirTeamTransaction,
                },
                {
                    path: 'shoptransactiontj',
                    name: 'shoptransactiontj',
                    component: ShopTransactionTj,
                },
                {
                    path: 'shopvolumetj',
                    name: 'shopvolumetj',
                    component: ShopVolumeTj,
                },
                {
                    path: 'shopvolumetjtwo',
                    name: 'shopvolumetjtwo',
                    component: ShopVolumeTjTwo,
                },
                {
                    path: 'agentvolumetj',
                    name: 'agentvolumetj',
                    component: AgentVolumeTj,
                },
                {
                    path: 'shopactivationlook',
                    name: 'shopactivationlook',
                    component: ShopActivationLook,
                },
                {
                    path: 'revenuestatistics',
                    name: 'revenuestatistics',
                    component: RevenueStatistics,
                },
                {
                    path: 'ecbargraph',
                    name: 'ecbargraph',
                    component: EcBarGraph,
                },
                { //代理商
                    path: 'ecpie',
                    name: 'ecpie',
                    component: EcPie,
                },
                {
                    path: 'eclinechart',
                    name: 'eclinechart',
                    component: EcLineChart,
                },
                {
                    path: 'ecagelinechart',
                    name: 'ecagelinechart',
                    component: EcAgeLineChart,
                },
                { //商户
                    path: 'merchantecpie',
                    name: 'merchantecpie',
                    component: MerchantEcPie,
                },
                {
                    path: 'merchanteclinechart',
                    name: 'merchanteclinechart',
                    component: MerchantEcLineChart,
                },
                {
                    path: 'merchantecagelinechart',
                    name: 'merchantecagelinechart',
                    component: MerchantEcAgeLineChart,
                },
                //财务
                {
                    path: 'bonusplan',
                    name: 'bonusplan',
                    component: BonusPlan,
                },
                {
                    path: 'transferaccountssh',
                    name: 'transferaccountssh',
                    component: TransferAccountsSh,
                },
                //网申卡
                {
                    path: 'onlineapplicationcardresources',
                    name: 'onlineapplicationcardresources',
                    component: OnlineApplicationCardResources,
                },
                {
                    path: 'onlineapplicationcardmanage',
                    name: 'onlineapplicationcardmanage',
                    component: OnlineApplicationCardManage,
                },
                {
                    path: 'meronlineapplicationcardmanage',
                    name: 'meronlineapplicationcardmanage',
                    component: MerOnlineApplicationCardManage,
                },
                {
                    path: 'onlinecardresult',
                    name: 'onlinecardresult',
                    component: OnlineCardResult,
                },
                {
                    path: 'onlinecard',
                    name: 'onlinecard',
                    component: OnlineCard,
                },
                //排行榜管理
                {
                    path: 'rankingmanage',
                    name: 'rankingmanage',
                    component: RankIngManage,
                },
                {
                    path: 'monthlylist',
                    name: 'monthlylist',
                    component: MonthlyList,
                },
                {
                    path: 'weeklist',
                    name: 'weeklist',
                    component: WeekList,
                },
                {
                    path: 'integrallist',
                    name: 'integrallist',
                    component: IntegralList,
                },
                {
                    path: 'rewardlist',
                    name: 'rewardlist',
                    component: RewardList,
                },
                //新排行榜管理
                {
                    path: 'newrankingmanage',
                    name: 'newrankingmanage',
                    component: NewRankIngManage,
                },
                {
                    path: 'newmonthlylist',
                    name: 'newmonthlylist',
                    component: NewMonthlyList,
                },
                {
                    path: 'newintegrallist',
                    name: 'newintegrallist',
                    component: NewIntegralList,
                },
                {
                    path: 'newrewardlist',
                    name: 'newrewardlist',
                    component: NewRewardList,
                },
                //富有管理
                {
                    path: 'merchantaccess',
                    name: 'merchantaccess',
                    component: MerchantAccess,
                },
                //POSP管理
                {
                    path: 'merchantSupplierManagement',
                    name: 'merchantSupplierManagement',
                    component: merchantSupplierManagement,
                },
                // 易生管理
                {
                    path: 'AyiSheng',
                    name: 'AyiSheng',
                    component: AyiSheng,
                    meta: {keepAlive: true}
                },
                {
                    path: 'AyiShengChild',
                    name: 'AyiShengChild',
                    component: AyiShengChild,
                },
                {
                    path: 'AyiShengMoney',
                    name: 'AyiShengMoney',
                    component: AyiShengMoney,
                },
                // 通道商户
                {
                    path: 'channelMerchant',
                    name: 'channelMerchant',
                    component: channelMerchant,
                },
                // 终端管理
                {
                    path: 'POSPTerminalManagement',
                    name: 'POSPTerminalManagement',
                    component: POSPTerminalManagement,
                },
                // 通道终端
                {
                    path: 'ChannelTerminal',
                    name: 'ChannelTerminal',
                    component: ChannelTerminal,
                },
            ]
        },
    ]
});



// WEBPACK FOOTER //
// ./src/router/index.js